module.exports = __webpack_public_path__ + "static/media/remove-circle.07a4bafb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/remove-circle.svg
// module id = 980
// module chunks = 0